import { Button, Divider, Drawer, Form, Input, Radio } from "antd";
import React from "react";
import { colors } from "../../../../Utils/temas";
import { SearchOutlined, ClearOutlined } from "@ant-design/icons";
const { useForm, Item } = Form;
const { Group } = Radio;

export const DrawerFilter = ({ visible, onClose, onFinish, limpar }) => {
  const [form] = useForm();
  return (
    <Drawer visible={visible} onClose={onClose} title="Filtros">
      <Form
        form={form}
        onFinish={onFinish}
        layout="vertical"
        style={{ fontWeight: "500" }}
      >
        <Item name="ticket" label="Ticket:">
          <Input />
        </Item>

        <Item name="em_teste" label="Em teste:">
          <Group>
            <Radio value={true}>Sim</Radio>
            <Radio value={false}>Não</Radio>
          </Group>
        </Item>

        <div>
          <Divider />

          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <Button
              style={{
                background: colors.secondary,
                color: "white",
                fontWeight: "500",
              }}
              className="botao"
              icon={<SearchOutlined />}
              htmlType="submit"
            >
              Pesquisar
            </Button>

            <Button
              icon={<ClearOutlined />}
              onClick={() => {
                limpar();
                onClose();
                form.resetFields();
              }}
            >
              Limpar
            </Button>
          </div>
        </div>
      </Form>
    </Drawer>
  );
};
